import { Chart } from 'highcharts'
import { DateTime } from 'luxon'

import { CHART_TYPE, VIEW_PERIOD, VIEW_PERIOD_PICKER, XAXIS_TYPE, YAXIS_TYPE } from '../../src/constants/chart-related.constant'
import { DATA_GROUP } from '../../src/constants/common.constant'
import { DATE_FORMAT, DATE_FORMAT_TYPE } from '../../src/constants/date.constant'
import { IChartContainer } from '../../src/types/chart-conatiner.type'
import { IChartOptions } from '../../src/types/chart-options.type'
import { IChartWatermark } from '../../src/types/chart-watermark.type'

export const getDefaultChartContainer = ():IChartContainer => {
  return {
    title: '',
    additionalFunc: {
      useDownload: false,
      useScreenshot: false,
      useShare: false,
    },
    chartFunc: {
      useDataGroup: false,
      useLinearLog: false,
      useMovingAverage: false,
    },
    description: '',
    source: '',
  }
}

export const getDefaultChartOptions = ():IChartOptions => {
  return {
    viewPeriodOptions: {
      showPeriodPicker: false,
      viewPeriodList: VIEW_PERIOD_PICKER.DEFAULT,
      selectedViewPeriod: VIEW_PERIOD['1_ALL'],
      stDate: DateTime.now().minus({ day: 2 }).toFormat(DATE_FORMAT.DEFAULT_FORMAT),
      endDate: DateTime.now().minus({ day: 1 }).toFormat(DATE_FORMAT.DEFAULT_FORMAT)
    },
    xAxisOptions: {
      title: '',
      type: XAXIS_TYPE.DATETIME,
      standard: 'day',
      categories: []
    },
    yAxisOptions: {
      useAbsMinMaxBySeries: false,
      left: {
        title: '',
        type: YAXIS_TYPE.LINEAR,
        unit: '',
        softMin: 0,
        max: null,
        decimalPoint: 18,
        contraction: true,
      },
      right: {
        title: '',
        type: YAXIS_TYPE.LINEAR,
        unit: '',
        softMin: 0,
        max: null,
        decimalPoint: 18,
        contraction: true,
      },
    },
    tooltipOptions: {
      dateFormat: DATE_FORMAT_TYPE.DEFAULT_FORMAT,
      dataGroup: DATA_GROUP.DAY,
      title: '',
      commonContents: '',
      showDecimalZero: true,
      contraction: true,
    },
    legendOptions: {
      showYAxisPosToLegend: false,
    },
    chartDataList: [],
    showNavigator: false,
    dateFormatLang: 'en',
  }
}

export const addWatermark = (chart: Chart, chartType:string, watermark: IChartWatermark) => {
  const defaultWatermarkWidth = 200
  const defaultWatermarkHeight = 40

  let posX = (chart.chartWidth / 2) - (watermark.width ? watermark.width / 2 : defaultWatermarkWidth / 2)
  let posY = (chart.plotHeight / 2) + (watermark.height ? watermark.height / 2 : defaultWatermarkHeight / 2)
  if (chartType === CHART_TYPE.PIE) {
    posX = (chart.plotWidth / 2) - (watermark.width ? watermark.width / 2 : defaultWatermarkWidth / 2)
    posY = (chart.plotHeight / 2) + (watermark.height ? watermark.height / 2 : defaultWatermarkHeight / 2)
  }
  // console.log('chart.chartWidth', chart.chartWidth)
  // console.log('watermark.width', watermark.width)
  // console.log('posX', posX)
  // console.log('posY', posY)
  try {
    return chart.renderer.image(watermark.img, posX, posY, watermark.width ?? defaultWatermarkWidth, watermark.height ?? defaultWatermarkHeight)
      .attr({
        zIndex: -1,
        opacity: watermark.opacity ?? 0.2,
      })
      .add()
  } catch (e) {
    console.log(e)
    return null
  }
}